import React from "react";
import { Row, Col, Typography, Tooltip } from "antd";
import styled from "styled-components";
import {nFormatter,capitalize} from "utils/randomString"

const { Title, Text } = Typography;
const Card = styled.div`
  background: linear-gradient(
    143.89deg,
    rgba(232, 240, 252, 0.5) -18.38%,
    rgba(201, 228, 223, 0.5) 102.64%
  );
  padding: 20px;
  border-radius: 8px;
  margin-right: 24px;
`;

const StatCard = ({ title, heading }) => {
  return (
    <Col span={8}>
      <Card>
        <Row justify="space-between" align="middle">
          <Col>
            <Text style={{ color: "#363E3D" }}>{heading}</Text>
          </Col>
        </Row>
        <Row style={{ marginTop: "0.75em" }}>
          <Tooltip title={title}>
            <Title level={4} ellipsis>
              {title}
            </Title>
          </Tooltip>
        </Row>
      </Card>
    </Col>
  );
};
export default function Stats({
  data,
  mostImportedProduct
}) {

  // const mostImportedProduct= Math.max(hscode_distribution.map())

  return (
    <Row style={{ marginTop: "1.5em" }}>
      <StatCard heading={"Most imported product"} title={capitalize(mostImportedProduct)} />

      <StatCard
        heading={"Trading partners"}
        title={`${data?.overall_trading_partners} in India`}
      />

      <StatCard
        heading={"Trade value"}
        title={`$ ${nFormatter(data?.overall_trade_value,1)}` }
      />
    </Row>
  );
}
